module.exports = __webpack_public_path__ + "static/img/gliders-tile-instrument.cc7e592.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gliders-tile-instrument.jpg
// module id = NPRs
// module chunks = 1